// Orgs with a dedicated feature page on THE WALL (beyond /organizations/:id).
const FEATURE_PAGES = [
  { match: /skoolie/i, path: "/skoolie", label: "Washington's Skoolie Foundation" },
];

export const orgFeaturePage = (org) => {
  const name = (org?.name || "").toString();
  return FEATURE_PAGES.find((f) => f.match.test(name)) || null;
};
